module.exports = __webpack_public_path__ + "static/media/who-we-are.cbb505a8.png";